import { getMediaFileId } from './getMediaFileId';

export const POSITION_SETS = [
	['50% 28%', '50% 48%', '50% 68%'],
	['46% 30%', '52% 50%', '58% 70%'],
	['54% 26%', '48% 50%', '46% 72%'],
];

export const STORY_SCALES = [1.04, 1.14, 1.24];

export const STORIES_BAR_SKELETON_COUNT = 8;

export const getPreviewMediaId = (person, media, type) => {
	if (type === 'video') {
		return getMediaFileId(person.profile_image);
	}

	return getMediaFileId(media);
};
